module.exports = __webpack_public_path__ + "87682f1c27d4b4be9ea0a892724e9aac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-witch-s.png
// module id = 2916
// module chunks = 0